import { render, staticRenderFns } from "./MenuListView.vue?vue&type=template&id=2d6b2611&scoped=true&"
import script from "./MenuListView.vue?vue&type=script&lang=js&"
export * from "./MenuListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b2611",
  null
  
)

export default component.exports